import React from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";
import Input from "../../components/shared/Input";
import Button from "../../components/shared/Button";

// --- STYLE OBJECTS ---

const pageStyle: React.CSSProperties = {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#000000',
};

const mainContentStyle: React.CSSProperties = {
    backgroundImage: "url(/assets/img/landing/landing-bg.png)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    minHeight: '100vh',
    position: 'relative',
    paddingTop: '1.5rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
};

const welcomeHeadingStyle: React.CSSProperties = {
    fontSize: '3rem',
    fontWeight: 700,
    color: 'white',
    marginBottom: '2rem',
};

const gridContainerStyle: React.CSSProperties = {
    width: '100%',
    maxWidth: '72rem',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '2rem',
};

const sectionStyle: React.CSSProperties = {
    color: 'white',
    marginBottom: '2rem',
    backgroundColor: '#0D0D0D',
    padding: '1.5rem',
    borderRadius: '0.5rem',
    border: '1px solid #3A3A3A',
};

const sectionTitleStyle: React.CSSProperties = {
    fontSize: '1.5rem',
    lineHeight: '2rem',
    fontWeight: 700,
    marginBottom: '1rem',
    color: 'white',
    textTransform: 'uppercase',
    fontFamily: '"Old English Text MT", serif',
    backgroundImage: 'url("/assets/img/landing/d.png")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
};

const pStyle: React.CSSProperties = {
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    color: '#9CA3AF',
    marginBottom: '1rem',
    fontFamily: '"Lato", sans-serif',
};

const pBoldStyle: React.CSSProperties = { ...pStyle, fontWeight: 700 };

// --- REFACTORED COMPONENTS ---

const Section = ({ title, children }: { title: string, children: React.ReactNode }) => (
    <div style={sectionStyle}>
        <h2 style={sectionTitleStyle}>{title}</h2>
        <div>{children}</div>
    </div>
);

const UserInformation = () => (
    <Section title="User Information">
        <p style={pStyle}>You can change your nickname once every week, the first change will be free of charge, while the next rename attempts will require a fixed sum freemium and premium currencies.</p>
        <p style={pStyle}>
            -Your nickname can't contain swear or racist words;<br/>
            -You can't use the nickname of a Staff member of iPlayMore;<br/>
            -Your unique ID can't be changed;<br/>
            -Being reported for using an inappropriate nickname will result in a penalty to your account based on the gravity of your nickname. Your nickname will be replaced with an automatically generated name until you change it; this change is free of charge.
        </p>
        <p style={pBoldStyle}>Rename cost: Free of charge!</p>
        <div style={{ marginTop: '1rem' }}>
            <div style={{ marginBottom: '1rem' }}>
                <p style={{ ...pStyle, color: 'white', marginBottom: '0.25rem' }}>Nickname</p>
                <Input type="text" value={"Nickname"} onChange={() => {}} placeholder="Nickname" className="!h-[51px]" />
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <Input type="text" value={"OldNickname"} disabled onChange={() => {}} placeholder="OldNickname" className="!h-[51px] bg-gray-800" />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button className="w-[98px] !h-[51px]">Back</Button>
                <Button className="w-[150px] !h-[51px]">Change Nickname</Button>
            </div>
        </div>
    </Section>
);

const Inventory = () => (
    <Section title="Inventory">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <p style={{ ...pStyle, color: '#D1D5DB' }}>Total Items: 0</p>
            <Button className="w-[98px] !h-[51px]">Browse</Button>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
                <p style={{ ...pStyle, color: '#D1D5DB' }}>Total slots: 0</p>
                <p style={{ ...pStyle, color: '#D1D5DB' }}>Available: 0</p>
            </div>
            <Button className="w-[98px] !h-[51px]">Add</Button>
        </div>
    </Section>
);

interface CurrencyProps {
    name: string;
    description: string;
    icon: string;
    amount: number;
    showAddButton: boolean;
}

const Currency = ({ name, description, icon, amount, showAddButton }: CurrencyProps) => (
    <div style={sectionStyle}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <img src={icon} alt={name} style={{ width: '3rem', height: '3rem', marginRight: '1rem' }}/>
                <p style={{ fontWeight: 700, fontSize: '1.125rem', lineHeight: '1.75rem' }}>{name}</p>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ fontWeight: 700, fontSize: '1.5rem', lineHeight: '2rem', marginRight: '1rem' }}>{amount}</p>
                {showAddButton && <Button className="w-[98px] !h-[51px]">Add</Button>}
            </div>
        </div>
        <p style={{ ...pStyle, marginLeft: '4rem' }}>{description}</p>
    </div>
);

const Currencies = () => (
    <div>
        <Currency name="Manna" description="Premium currency used to purchase gear, devices, scepters, and more through the marketplace." icon="/assets/img/manna-icon.png" amount={0} showAddButton={true} />
        <Currency name="Solar" description="Currency used to purchase rare items, minerals, and to rent gear from other players." icon="/assets/img/solar-icon.png" amount={0} showAddButton={false} />
        <Currency name="Lunar" description="Currency used to purchase common and uncommon resources from merchants in game." icon="/assets/img/lunar-icon.png" amount={0} showAddButton={false} />
    </div>
);

const TwitchAccount = () => (
    <div style={sectionStyle}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <h2 style={{...sectionTitleStyle, marginBottom: 0, backgroundImage: 'none' }}>Twitch Account</h2>
            <Button className="w-[150px] !h-[51px]">Link account</Button>
        </div>
        <p style={pStyle}>{`Link your account to obtain exclusive rewards by watching iPlayMore & Partners streams! If your Twitch account is eligible, you will be able to use our Streamer Tool to host unique giveaways!`}</p>
    </div>
);

const DeleteAccount = () => (
    <div style={{ marginBottom: '2rem' }}>
        <div style={{ ...sectionStyle, marginBottom: '0.5rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2 style={{...sectionTitleStyle, marginBottom: 0, backgroundImage: 'none' }}>Delete Account</h2>
                <Button className="w-[150px] !h-[51px] bg-red-600">Delete Account</Button>
            </div>
        </div>
        <p style={{ ...pStyle, color: '#EF4444', marginTop: '0.5rem' }}>Once you delete your account, it can’t be recovered.</p>
    </div>
);

const JgProfilePage = () => {
  const nickname = "Nickname";

  return (
    <div style={pageStyle}>
      <Header />
      <div style={mainContentStyle}>
        <h1 style={welcomeHeadingStyle}>Welcome, {nickname}</h1>
        <div style={gridContainerStyle}>
            <div>
              <UserInformation />
              <Inventory />
            </div>
            <div>
              <Currencies />
              <TwitchAccount />
              <DeleteAccount />
            </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default JgProfilePage;
